const apiUrl = process.env.REACT_APP_API_URL;
const bearerToken = process.env.REACT_APP_TOKEN_BEARER;

export { apiUrl, bearerToken };